import * as React from 'react';
import { Fragment } from 'react';
import { Route } from 'react-router-dom';
import Routes from '../constants/Routes';
import PrivateRoute from '../components/PrivateRoute';
import Main from './Site/Main';
import About from './Pages/About';
import PrivTest from './Pages/PrivTest';
import AuthLogin from './Auth/AuthLogin';
import Settings from './Settings/Settings';
import Login from './Auth/Login';
import Signup from './Auth/Signup';
import PropTest from './Pages/PropTest';
import ConfirmSignup from './Auth/ConfirmSignup';
import Privacy from './Pages/Privacy';
import Terms from './Pages/Terms';
import Portfolio from './Portfolio/Portfolio';
import Favorites from './Favorites/Favorites';
import Calculator from './Calculator/Calculator';

const App: React.SFC = () => (
  <Fragment>
    <Route exact path={Routes.main} component={Main} />
    <Route exact path={Routes.login} component={Login} />
    <Route exact path={Routes.authLogin} component={AuthLogin} />
    <Route exact path={Routes.signup} component={Signup} />
    <Route exact path={Routes.confirmSignup} component={ConfirmSignup} />
    <Route exact path={Routes.props} component={PropTest} />
    <Route exact path={Routes.about} component={About} />
    <Route exact path={Routes.privacy} component={Privacy} />
    <Route exact path={Routes.terms} component={Terms} />
    <PrivateRoute exact path={Routes.favorites} component={Favorites} />
    <PrivateRoute exact path={Routes.portfolio} component={Portfolio} />
    <PrivateRoute exact path={Routes.calculator} component={Calculator} />
    <PrivateRoute exact path={Routes.settings} component={Settings} />
    <PrivateRoute exact path={Routes.privTest} component={PrivTest} />
  </Fragment>
);

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.tsx